import { useQuery } from "@tanstack/react-query";

import { apiGet } from "@/lib/api";
import type { PublicPlan } from "@/lib/plans";

export const publicPlansQueryKey = ["public-plans"] as const;

/** Planos ativos cadastrados no admin, para a seção de oferta. */
export function usePublicPlans() {
  return useQuery({
    queryKey: publicPlansQueryKey,
    queryFn: async () => {
      const body = await apiGet<{ data?: PublicPlan[] }>("/plans/public");
      return Array.isArray(body?.data) ? body.data : [];
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
